import { useState } from "react";
import { useSelector } from "react-redux";

export const useProductReview = (props = {}) => {
  const { isSignedIn } = useSelector((state) => state.loginSlice);
  const { AddReview, product, handleCloseReviewModal } = props;
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState(false);
  const [summary, setSummary] = useState("");
  const [summaryError, setSummaryError] = useState("");
  const [currentValue, setCurrentValue] = useState({});
  const [hoverValue, setHoverValue] = useState(undefined);
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [userData, setUserData] = useState(
    JSON.parse(localStorage.getItem("userData"))
  );

  const handleMouseLeave = () => {
    setHoverValue(undefined);
  };

  const handleClick = (item, attributeId) => {
    setCurrentValue((prevState) => ({
      ...prevState,
      [attributeId]: {
        id: item.value_id,
        value: item.value,
      },
    }));
  };

  const isValidDescription = () => {
    if (description.trim() !== "") {
      if (description.length < 10) {
        setDescriptionError("Description should be atleast 10 characters");
        return false;
      } else {
        setDescriptionError("");
        return true;
      }
    } else if (description.trim() === "") {
      setDescriptionError("This is a required field! ");
      return false;
    } else {
      setDescriptionError("");
      return true;
    }
  };
  const isValidSummary = () => {
    if (summary.trim() !== "") {
      if (summary.length < 10) {
        setSummaryError("Summary should be atleast 10 characters");
        return false;
      } else {
        setSummaryError("");
        return true;
      }
    } else if (summary.trim() === "") {
      setSummaryError("This is a required field! ");
      return false;
    } else {
      setSummaryError("");
      return true;
    }
  };
  const isValidName = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setNameError("Name is required");
      return false;
    }
    const isValid = /^[A-Za-z]{2,}(?:[\s'-][A-Za-z]{2,})*$/.test(trimmed);
    if (!isValid) {
      setNameError("Only alphabets allowed");
      return false;
    }
    if (trimmed.length > 30) {
      setNameError("Name exceeds the maximum character limit of 50");
      return false;
    }
    setNameError("");
    return true;
  };

  const validate = () => {
    if (isSignedIn) {
      if (isValidDescription() && isValidSummary()) {
        return true;
      } else {
        isValidDescription();
        isValidSummary();
      }
    } else {
      if (isValidDescription() && isValidSummary() && isValidName) {
        return true;
      } else {
        isValidDescription();
        isValidSummary();
        isValidName();
      }
    }

    return false;
  };

  const handleSubmit = () => {
    if (validate()) {
      AddReview({
        variables: {
          sku: product.sku,
          nickname: isSignedIn ? userData?.firstname : name,
          summary: summary,
          description: description,
          ratings: Object.entries(currentValue).map(([key, value]) => {
            return { id: key, value_id: value.id };
          }),
        },
      });
      handleCloseReviewModal();
      setDescription("");
      setSummary("");
      setCurrentValue({});
    } else {
      return;
    }
  };

  return {
    handleMouseLeave,
    handleClick,
    description,
    summary,
    setDescription,
    setSummary,
    descriptionError,
    summaryError,
    hoverValue,
    currentValue,
    handleSubmit,
    isValidDescription,
    isValidSummary,
    name,
    setName,
    nameError,
    isValidName,
  };
};
